import globalAxios from "../../../util/Api";
import { GET_VACATION_OVERVIEW, START_LOADING, STOP_LOADING, VACATION_RESET } from "./types";
import { LogoutAction } from "../../../actions";

export const GetVacationOverview = (yearField) => {
  return (dispatch) => {
    dispatch({ type: VACATION_RESET })
    globalAxios().get(`/api/v1/reports/vacation_overview?year=${yearField}`)
      .then(({ data }) => {
        const binaryString = atob(data);
        const len = binaryString.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i += 1) {
          view[i] = binaryString.charCodeAt(i);
        }
        const blob = new File([view], { type: 'application/vnd-xls' });
        const href = window.URL.createObjectURL(blob);
        if (data) {
          dispatch({ type: GET_VACATION_OVERVIEW, payload: href })
        }

      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
